<template>
    <div>
        <div class="p-6 bg-white border shadow my-rounded">
            <div
            v-if="!isOpen"
            >
                <div @click="openCard()">
                    <slot name="close">
                        <div class="flex items-center justify-between">
                            <div>
                                <h5 class="mb-0 capitalize" v-html="title"></h5>
                            </div>
                            <i class="fas fa-angle-right"></i>
                        </div>
                    </slot>
                </div>
            </div>
            <div v-if="isOpen">
                <div class="flex items-center justify-between">
                    <div>
                        <h5 class="mb-0 text-2xl font-bold" v-html="title"></h5>
                        <div v-if="state">
                            <span v-if="state == 0" class="inline-block p-1 text-sm font-semibold leading-none text-center text-gray-800 text-gray-900 align-baseline bg-gray-100 border rounded hover:bg-gray-200">{{$t('composants.fold_card.en_cours_de_traitement')}}</span>
                            <span v-if="state == 2" class="inline-block p-1 text-sm font-semibold leading-none text-center text-white align-baseline bg-red-600 border rounded hover:bg-red-700">{{$t('composants.fold_card.refusee')}}</span>
                        </div>
                    </div>
                    <button v-if="closeButton" class="inline-block p-0 px-3 py-1 font-normal text-lg leading-normal text-center text-red-600 hover:text-red-700 duration-200 no-underline" @click="isOpen = false">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div>
                    <slot name="open"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import eventHub from '@/eventHub'
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        value: {
            type: Boolean,
            required: false
        },
        state: {
            required: false
        },
        id: {
            type: String
        },
        closeButton: {
            type: Boolean,
            default: true
        },
        canOpen: {
            type: Object,
        }
    },

    watch: {
        value: function (value) {
            this.isOpen = value
        },

        isOpen: function(value) {
            this.$emit('input', value)
            eventHub.$emit('card-open-close', {
                itemId: this.id,
                value: this.isOpen
            })
        }
    },

    data() {
        return {
            isOpen: false
        }
    },

    methods: {
        openCard() {
            if (this.canOpen == null || this.canOpen.authorize) {
                this.isOpen = true
            } else {
                if (this.canOpen.message) {
                    this.$toast.warning(this.canOpen.message)
                }
            }
        }
    },

    mounted() {
        this.isOpen = this.value

        eventHub.$on('open-card', (cardName) => {
            if (this.id && cardName == this.id) {
                this.isOpen = true
            }
        })

        eventHub.$on('close-all-cards', (excepts) => {
            if (!excepts.includes(this.id)) {
                this.isOpen = false
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SavFoldCard.vue